import yup from "../../../../../utils/yup-extended";
import {
  FILE_LIMIT,
  hasAllowedExtension,
  MAX_FILE_SIZE,
} from "../evidence-of-delivery-upload";

export const serviceOrderDeliverWorkFormValidationSchema = yup.object().shape({
  completedWorkLinks: yup
    .array()
    .of(
      yup.object().shape({
        link: yup.string().trim().urlWithEmoji().required("Link is required"), // <- nice and tidy
      })
    )
    .min(1, "Add at least one"),
  evidenceOfDelivery: yup
    .array()
    .transform((value) => (Array.isArray(value) ? value : []))
    .of(
      yup
        .mixed<File>()
        .test("is-file", "Invalid file", (value) => value instanceof File)
        .test("allowed-type", "Invalid file ext", (value) => {
          if (!value) return false;
          return hasAllowedExtension(value);
        })
        .test("file-size", "Each file must be under 5MB", (value) => {
          if (!value) return true;
          return value.size <= MAX_FILE_SIZE;
        })
        .test("debug", "Debug", (value) => {
          console.log("VALUE IN YUP:", value);
          return true;
        })
    )
    .min(1, "At least one file is required")
    .max(FILE_LIMIT, `Max ${FILE_LIMIT} files allowed`)
    .required("Upload evidence of delivery")
    .default([]),
});

export type ServiceOrderDeliverWorkFormValuesYup = yup.InferType<
  typeof serviceOrderDeliverWorkFormValidationSchema
>;
export type ServiceOrderDeliverWorkFormValues = {
  completedWorkLinks: {
    link: string;
  }[];
  evidenceOfDelivery: File[];
};
